/* Óskalisti (BamBam House): hjarta á vörusíðum og í haus, listinn geymdur í vafra gestsins.
   Síðan /pages/oskalisti sýnir listann, deilihlekk og jólagjafahugmyndir. */
(function () {
  var KEY = 'bb_oskalisti';
  var FULL = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.2-4.4-9.2-8.8C1.4 8.4 3.4 4.8 6.9 4.8c2 0 3.5 1.1 4.2 2.3h1.8c.7-1.2 2.2-2.3 4.2-2.3 3.5 0 5.5 3.6 4.1 6.9-2 4.4-9.2 8.8-9.2 8.8z" fill="currentColor"/></svg>';
  var LINE = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.2-4.4-9.2-8.8C1.4 8.4 3.4 4.8 6.9 4.8c2 0 3.5 1.1 4.2 2.3h1.8c.7-1.2 2.2-2.3 4.2-2.3 3.5 0 5.5 3.6 4.1 6.9-2 4.4-9.2 8.8-9.2 8.8z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('oskalisti:change'));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var l = read();
    var i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    write(l.slice(0, 60));
  }
  window.BBOskalisti = { read: read, write: write, has: has, toggle: toggle, FULL: FULL, LINE: LINE };

  var css = document.createElement('style');
  css.textContent =
    '.bb-osk-head{position:relative;color:inherit;}' +
    '.bb-osk-head svg{width:2rem;height:2rem;}' +
    '.bb-osk-count{position:absolute;bottom:.8rem;right:.4rem;min-width:1.7rem;height:1.7rem;padding:0 .4rem;border-radius:1rem;background:#532029;color:#fff;font-size:1rem;line-height:1.7rem;text-align:center;}' +
    '.bb-osk-count[hidden]{display:none;}' +
    '.bb-osk-btn{display:flex;align-items:center;justify-content:center;gap:.8rem;width:100%;margin:1rem 0 0;padding:1.2rem 1.6rem;border:1px solid rgba(83,32,41,.35);background:transparent;color:#532029;font:inherit;font-size:1.4rem;letter-spacing:.06rem;cursor:pointer;}' +
    '.bb-osk-btn.is-on{background:#EDE1FF;border-color:#EDE1FF;}' +
    '.bb-osk-heart{position:absolute;top:.8rem;right:.8rem;z-index:2;display:flex;align-items:center;justify-content:center;width:3.6rem;height:3.6rem;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#532029;cursor:pointer;}';
  document.head.appendChild(css);

  function headerIcon() {
    var icons = document.querySelector('.header__icons');
    if (!icons) return;
    var a = icons.querySelector('[data-osk-header]');
    if (!a) {
      a = document.createElement('a');
      a.href = '/pages/oskalisti';
      a.className = 'header__icon link focus-inset bb-osk-head';
      a.setAttribute('data-osk-header', '');
      a.setAttribute('aria-label', 'Óskalisti');
      a.innerHTML = LINE + '<span class="bb-osk-count" hidden></span>';
      icons.insertBefore(a, icons.querySelector('#cart-icon-bubble'));
    }
    var n = read().length;
    var c = a.querySelector('.bb-osk-count');
    c.textContent = n;
    c.hidden = n === 0;
  }

  function productHeart() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m || document.querySelector('[data-osk-pdp]')) return;
    var form = document.querySelector('[id^="MainProduct-"] product-form');
    if (!form) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bb-osk-btn';
    b.setAttribute('data-osk-pdp', '');
    b.setAttribute('data-osk-toggle', decodeURIComponent(m[1]));
    form.parentNode.insertBefore(b, form.nextSibling);
  }

  function paint() {
    var btns = document.querySelectorAll('[data-osk-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = has(b.getAttribute('data-osk-toggle'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Taka af óskalista' : 'Bæta á óskalista');
      if (b.hasAttribute('data-osk-pdp')) {
        b.innerHTML = (on ? FULL : LINE) + '<span>' + (on ? 'Á óskalistanum þínum' : 'Bæta á óskalistann') + '</span>';
      } else {
        b.innerHTML = on ? FULL : LINE;
      }
    }
    headerIcon();
  }
  window.BBOskalisti.paint = paint;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-osk-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-osk-toggle'));
  });
  document.addEventListener('oskalisti:change', paint);
  window.addEventListener('storage', function (e) { if (e.key === KEY) paint(); });

  function init() { productHeart(); paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
